var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSleep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4995 39.6579C30.991 39.6579 39.4961 31.0259 39.4961 20.3778C39.4961 9.72966 30.991 1.09766 20.4995 1.09766C10.008 1.09766 1.50293 9.72966 1.50293 20.3778C1.50293 31.0259 10.008 39.6579 20.4995 39.6579Z",
    fill: "#293047",
    stroke: "#F5F1EE",
    strokeWidth: 1.71429
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4989 32.1336C22.1438 32.1336 23.4773 30.7802 23.4773 29.1107C23.4773 27.4413 22.1438 26.0879 20.4989 26.0879C18.854 26.0879 17.5205 27.4413 17.5205 29.1107C17.5205 30.7802 18.854 32.1336 20.4989 32.1336Z",
    fill: "#293047",
    stroke: "#F5F1EE",
    strokeWidth: 1.71429
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1224 17.7677C26.2309 18.4374 26.5397 19.0802 27.0486 19.5968C28.3425 20.91 30.4403 20.91 31.7342 19.5968C32.2168 19.107 32.5194 18.5036 32.642 17.8714",
    fill: "#293047"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1224 17.7677C26.2309 18.4374 26.5397 19.0802 27.0486 19.5968C28.3425 20.91 30.4403 20.91 31.7342 19.5968C32.2168 19.107 32.5194 18.5036 32.642 17.8714",
    stroke: "#F5F1EE",
    strokeWidth: 1.71429,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45244 17.7677C8.561 18.4374 8.86975 19.0802 9.37871 19.5968C10.6726 20.91 12.7704 20.91 14.0643 19.5968C14.5469 19.107 14.8495 18.5036 14.9721 17.8714",
    fill: "#293047"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45244 17.7677C8.561 18.4374 8.86975 19.0802 9.37871 19.5968C10.6726 20.91 12.7704 20.91 14.0643 19.5968C14.5469 19.107 14.8495 18.5036 14.9721 17.8714",
    stroke: "#F5F1EE",
    strokeWidth: 1.71429,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleep);
export default __webpack_public_path__ + "static/media/sleep.7a560fadb4d5e7f921a63ad4c1b7a6e6.svg";
export { ForwardRef as ReactComponent };